// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class TierPricingSettings {
  readonly tierPricing: boolean;
  readonly lowerTierPriceDeviationThreshold: string | null;
  readonly upperTierPriceDeviationThreshold: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.tierPricing = data.tierPricing === undefined ? false : data.tierPricing;
    this.lowerTierPriceDeviationThreshold =
      data.lowerTierPriceDeviationThreshold === undefined
        ? null
        : data.lowerTierPriceDeviationThreshold;
    this.upperTierPriceDeviationThreshold =
      data.upperTierPriceDeviationThreshold === undefined
        ? null
        : data.upperTierPriceDeviationThreshold;
  }

  static zero(): TierPricingSettings {
    const zeroValues: ExcludeMethodsDeep<TierPricingSettings> = {
      tierPricing: false,
      lowerTierPriceDeviationThreshold: null,
      upperTierPriceDeviationThreshold: null,
    };
    return new TierPricingSettings(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TierPricingSettingsWireFormat = {
  tierPricing: boolean;
  lowerTierPriceDeviationThreshold: string | null;
  upperTierPriceDeviationThreshold: string | null;
};

type NewTierPricingSettingsProps = PartialDeep<TierPricingSettings, { recurseIntoArrays: true }>;
export const NewTierPricingSettings: (props: NewTierPricingSettingsProps) => TierPricingSettings = (
  props,
) => new TierPricingSettings(props);

type NewTierPricingSettingsFromWireFormatProps = PartialDeep<
  TierPricingSettingsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewTierPricingSettingsFromWireFormat: (
  props: NewTierPricingSettingsFromWireFormatProps,
) => TierPricingSettings = (props) => new TierPricingSettings(props);
